import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LoadingSpinner } from '@/components/ui/loading-spinner';

interface ProtectedRouteProps {
  children: ReactNode;
  redirectTo?: string;
  requireEmailVerification?: boolean;
}

const ProtectedRoute = ({ 
  children, 
  redirectTo = "/login",
  requireEmailVerification = true 
}: ProtectedRouteProps) => {
  const { user, loading, isEmailVerified } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center h-screen">
        <LoadingSpinner size="lg" variant="default" />
        <p className="mt-4 text-sauna-navy font-medium">Loading...</p>
      </div>
    );
  }

  if (!user) {
    // Redirect to login page but save the attempted url
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  // Enforce email verification if required
  if (requireEmailVerification && !isEmailVerified() && location.pathname !== "/verify-email") {
    return <Navigate to="/verify-email" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
